import ShipmentTypeProvider from './ShipmentTypeDetailsContext';
import ShipmentTypeDetails from './ShipmentTypeDetails';
import { Page } from 'components';

let Index = () => {
    return (
        <ShipmentTypeProvider>
            <Page title="Shipment Type details" maxWidth='md'>
                <ShipmentTypeDetails />
            </Page>
        </ShipmentTypeProvider>
    )
}

export default Index;